import { wp, api } from '@/utils/client';

const state = {
}

// actions
const actions = {
	async fetchNotifications(context, notificationType) {
		try {
			let response = await api.get('/teams/' + context.rootState.teamId + '/notifications/' + notificationType);
			context.commit('fetchNotifications', {type: notificationType, data: response.data});
			return response;
		} catch (e) { console.log(e); throw e; }
	},
}

// mutations
const mutations = {
	fetchNotifications(state, data) {
	},
}

export default {
	state,
	actions,
	mutations
}
